import React, { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';
import { Element, useNode } from '@craftjs/core';

import PageHeader from './PageHeader';
import PageBody from './PageBody';
import PageFooter from './PageFooter';
import { EDITOR_RESOLVERS } from '@common/constants';
import { useTranslation } from 'react-i18next';
import { useTemplateConfig } from './TemplateContext';
import SettingsWrapper from '@common/components/SettingsWrapper/SettingsWrapper';
import SettingsRow from '@common/components/SettingsWrapper/SettingsRow';
import SelectColor from '@resolvers/tools/SelectColor/SelectColor';

export const PageLayout = ({ background }) => {
  const {
    connectors: { connect, drag },
    actions: { setCustom },
  } = useNode();

  const { showHeader, showFooter, pageSize } = useTemplateConfig();

  const { t } = useTranslation();
  const ref = useRef(null);

  useEffect(() => {
    if (ref?.current && connect) {
      connect(drag(ref.current));
    }
  }, [connect]);

  useEffect(() => {
    setCustom((props) => {
      props.displayName = t('page');
    });
  }, [setCustom, t]);

  return (
    <div
      className='page'
      ref={ref}
      style={{
        position: 'relative',
        width: `${pageSize?.width || '100'}px`,
        height: `${pageSize?.height || '100'}px`,
        backgroundColor: `${background}`,
        boxSizing: 'border-box',
        // overflowH: 'hidden',
        overflow: 'hidden',
      }}
    >
      {showHeader && (
        <Element
          id='pageHeader'
          is={PageHeader}
          canvas
          height={pageSize?.headersSize?.standard?.header}
        />
      )}
      <Element id='pageBody' is={PageBody} pageSize={pageSize} canvas />
      {showFooter && (
        <Element
          id='pageFooter'
          is={PageFooter}
          canvas
          height={pageSize?.headersSize?.standard?.footer}
        />
      )}
    </div>
  );
};

const PageLayoutConfigPanel = () => {
  return (
    <SettingsWrapper>
      <SettingsRow>
        <SelectColor />
      </SettingsRow>
    </SettingsWrapper>
  );
};

export const PageLayoutDefaultProps = {
  background: '#ffffff',
  elementProps: {},
  showHeader: false,
  showFooter: false,
};

PageLayout.defaultProps = PageLayoutDefaultProps;

PageLayout.propTypes = {
  background: PropTypes.string,
  elementProps: PropTypes.object,
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool,
};

PageLayout.craft = {
  displayName: EDITOR_RESOLVERS.PDF.PAGE_LAYOUT,
  name: EDITOR_RESOLVERS.PDF.PAGE_LAYOUT,
  props: PageLayoutDefaultProps,
  related: {
    settings: PageLayoutConfigPanel,
  },
};

export default PageLayout;
